import { Splide } from "@splidejs/splide";

export default () => ({
  index: 0,
  init() {
    let main = new Splide(this.$el, {
      type: 'fade',
      pagination: false
    });

    main.mount();

    main.on('move', newIndex => {
      this.index = newIndex;
    });
  }
})